const providerAccountConfig = {
  view: "providerAccount",
}

export default providerAccountConfig
